import axios from '@/plugins/axios';
import { useToast } from '@/composables/use-toast.js';
import { logApiError } from '@/services/api.js';
const { addToast } = useToast();


const baseUrl = '/api/rfp-applications';

export const createProposal = async (data) => {
    try {
        const response = await axios.post(`${baseUrl}`, data);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}`);
        addToast(error.response.data.message, 'error');
        return false;
    }
}
export const fetchMyProposals = async () => {
    try {
        const response = await axios.get(`${baseUrl}/my-proposals`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);
        addToast('Error fetching My RFP proposals', 'error');
        return false;
    }
}

export const fetchReviewProposals = async () => {
    try {
        const response = await axios.get(`${baseUrl}/proposals-to-approve`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);
        addToast('Error fetching Review RFP proposals', 'error');
        return false;
    }
}

export const fetchProposal = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}/${id}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);
        addToast('Error fetching RFP proposal', 'error');
        return false;
    }
}

export const approveProposal = async (id) => {
    try {
        const response = await axios.post(`${baseUrl}/approve/${id}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}`);
        addToast('Error approving RFP proposal', 'error');
        return false;
    }
}

export const rejectProposal = async (id) => {
    try {
        const response = await axios.post(`${baseUrl}/reject/${id}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}`);
        addToast('Error rejecting RFP proposal', 'error');
        return false;
    }
}

export const withdrawProposal = async (id) => {
    try {
        const response = await axios.post(`${baseUrl}/withdraw/${id}`,);
        return response.data;
    } catch (error) {
        logApiError(error, 'POST', `${baseUrl}`);
        addToast('Error withdrawing RFP proposal', 'error');
        return false;
    }
}

export const hasProposalAccepted = async (id) => {
    try {
        const response = await axios.get(`${baseUrl}/has-proposal-accepted/${id}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);
        addToast('Error checking if proposal has been accepted', 'error');
        return false;
    }
}

export const userHasProposalToListing = async (listingId) => {
    try {
        const response = await axios.get(`${baseUrl}/user-has-proposal/${listingId}`);
        return response.data;
    } catch (error) {
        logApiError(error, 'GET', `${baseUrl}`);
        addToast('Error checking if user has proposal listing', 'error');
        return false;
    }
}